<template>
  <div
    elevation
    class="show-market"
    link
    flat
    tile
    color=" lighten-2"
    @click="$router.push(`/project/${projectId}/market/${market.objectId}`)"
  >
    <div class="primary white--text px-3 py-2 rounded-t-lg">
      <h2 v-if="market && market.name" class="d-flex justify-space-between">
        <div>
          <v-icon left color="white">mdi-store</v-icon>
          {{ market.name }}
        </div>
        <div>
          {{ market.groupName || "" }}
        </div>
      </h2>
    </div>
    <div class="py-5 text-black rounded-b-lg block">
      <h3 class="px-5">
        <span class="text-sm">{{ $t('area.all_stall') }}</span>
        <span class="px-3 primary--text" v-if="marketInfo">{{ marketInfo.count }}</span>
        <v-progress-circular v-else :value="20" size="10" class="mx-3" indeterminate color="green"></v-progress-circular>

        <span class="text-sm">{{ $t('area.stall_and_rental_rate') }}</span>
        <span class="px-3 primary--text" v-if="marketInfo">{{ marketInfo.occupancyRate | arabic }}%</span>
        <v-progress-circular v-else :value="20" size="10" class="mx-3" indeterminate color="green"></v-progress-circular>

        <span class="text-sm">, {{ $t('area.space') }}</span>
        <span class="px-3 primary--text" v-if="marketInfo">{{ marketInfo.size | currency }}</span>
        <v-progress-circular v-else :value="20" size="10" class="mx-3" indeterminate color="green"></v-progress-circular>
        <span class="text-sm">{{ $t('area.square_meter_title') }}</span>
      </h3>
      <div class="grid grid-cols-6 gap-6 px-5 my-4">
        <div flat class="my-2" color="transparent" max-width="300" width="100%">
          <div class="d-flex gap-6">
            <v-icon left color="white" class="bg-red-500 p-3 rounded">mdi-file-document-multiple</v-icon>
            <div class="cardInfo">
              <span class="text-gray-400 text-sm">{{ $t('payment.pending') }} ({{ $t('area.space') }})</span>
              <span class="text-red-600 text-xl" v-if="marketInfo">
                {{ marketInfo.unpaid | arabic
                }}
                <span class="text-sm ml-2">
                  ({{
                  ((marketInfo.unpaid * 100) / marketInfo.occupied) | arabic
                  }}%)
                </span>
              </span>
              <v-progress-circular v-else :value="20" size="15" indeterminate color="green"></v-progress-circular>
            </div>
          </div>
        </div>
        <div flat class="my-2 d-block" color="transparent" max-width="300" width="100%">
          <div class="d-flex gap-6">
            <v-icon
              left
              color="white"
              class="bg-screamin-green-700 p-3 rounded"
            >mdi-account-multiple-check</v-icon>
            <div class="cardInfo">
              <span class="text-gray-400 text-sm">{{ $t('project.renter_title') }} ({{ $t('area.space') }})</span>
              <span class="text-primary text-xl" v-if="marketInfo">
                {{
                marketInfo.occupied | arabic
                }}
                <span
                  class="text-sm ml-2"
                >
                  ({{
                  ((marketInfo.occupied * 100) / marketInfo.count) | arabic
                  }}%)
                </span>
              </span>
              <v-progress-circular v-else :value="20" size="15" indeterminate color="green"></v-progress-circular>
            </div>
          </div>
        </div>
        <div flat class="my-2 d-block" color="transparent" max-width="300" width="100%">
          <div class="d-flex gap-6">
            <v-icon left color="white" class="bg-picton-blue-600 p-3 rounded">mdi-account</v-icon>
            <div class="cardInfo">
              <span class="text-gray-400 text-sm">{{ $t('area.empty_stall') }}</span>
              <span class="text-black text-xl" v-if="marketInfo">
                {{ marketInfo.vacancy | arabic}}
                <span class="text-sm ml-2">
                  ({{
                  ((marketInfo.vacancy * 100) / marketInfo.count) | arabic}}%)
                </span>
              </span>
              <v-progress-circular v-else :value="20" size="15" indeterminate color="green"></v-progress-circular>
            </div>
          </div>
        </div>
        <div flat class="my-2 d-block" color="transparent" max-width="300" width="100%">
          <div class="d-flex gap-6">
            <v-icon left color="white" class="bg-yellow-400 p-3 rounded">mdi-bullhorn-outline</v-icon>
            <div class="cardInfo">
              <span class="text-gray-400 text-sm">{{ $t('appeal.send_appeal') }}</span>
              <span class="text-black text-xl" v-if="marketInfo">{{ marketInfo.appeals | arabic}}</span>
              <v-progress-circular v-else :value="20" size="15" indeterminate color="green"></v-progress-circular>
            </div>
          </div>
        </div>
        <div flat class="my-2 d-block" color="transparent" max-width="300" width="100%">
          <div class="d-flex gap-6" v-if="project.role == 'admin'">
            <v-icon left color="white" class="bg-purple-500 p-3 rounded">mdi-clipboard-text-clock</v-icon>
            <div class="cardInfo">
              <span class="text-gray-400 text-sm">{{ $t('payment.wait_approval') }}</span>
              <span
                class="text-black text-xl"
                v-if="marketInfo"
              >{{ market.approveTask ? market.approveTask : 0 | arabic}}</span>
              <v-progress-circular v-else :value="20" size="15" indeterminate color="green"></v-progress-circular>
            </div>
          </div>
        </div>
        <div flat class="my-2 d-block" max-width="300" width="100%" color="transparent">
          <div class="justify-end d-flex">
            <v-btn color="warning" elevation="0">{{ $t('market.manage_market') }}</v-btn>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- <div
    v-if="!project.project.markets"
    flat
    height="200"
    class="justify-center mb-5 show-market d-flex align-center"
    color="white"
    rounded="md"
  >
    <div class="text-center">
      <v-icon color="grey" size="50" class="mb-2"
        >mdi-emoticon-sad</v-icon
      >
      <h2>ยังไม่มีตลาด</h2>
      <p>
        สร้างตลาดที่โปรเจคนี้โดยคลิ๊กที่ปุ่ม
      </p>
      <v-icon color="">mdi-plus-box</v-icon>
    </div>
  </div>-->
</template>

<script>
export default {
  name: "ProjectMarket",
  props: {
    market: Object,
    projectId: String,
    marketInfo: Object,
    project: Object
  }
};
</script>

<style lang="scss" scoped>
.add-market {
  background: linear-gradient(135deg, #e2b0ff, #9f44d3);
}

.show-market {
  @apply transition-all  hover:shadow-xl rounded-lg cursor-pointer focus:text-gray-100 bg-white;
}

.cardInfo {
  @apply flex flex-col justify-center;
}
</style>
